



























import { defineComponent } from '@vue/composition-api';
import runInjection from '@/injection';
import PageFrame from '@/components/atoms/PageFrame.vue';
import HeaderMenu from '@/components/pages/HeaderMenu.vue';
import MainPage from '@/components/pages/MainPage.vue';

export default defineComponent({
  name: 'App',

  components: { PageFrame, HeaderMenu, MainPage },

  setup() {
    runInjection();
  },
});
